(function ($) {
    $.fn.tabbedContent = function () {

        let $tabbedContent, $tabSelectContainer, $tabSelect, $sortByToggle;

        this.each((index, element) => {

            $tabbedContent = $(element);
            $tabSelectContainer = $tabbedContent.find('.tab-select');
            $tabSelect = $tabSelectContainer.find('.custom-select');
            $sortByToggle = $tabSelect.find('#'+ $tabSelectContainer.attr('data-select-id') +'-dropdown');

            // On tab change
            $tabSelect.on('fr:update-custom-select', () => {
                let triggerEl = document.querySelector('#'+$($sortByToggle).val()+'-tab');
                let selectedTab = new window.Tab(triggerEl);
                selectedTab.show();
            });
        });

        return this;
    }

    $(() => {
        $('.tabbed-content').tabbedContent();
    })

})($);




// WEBPACK FOOTER //
// ./scripts/modules/blocks/tabbed-content.js